
const operatorItemList = [
  { value: "", text: "Unspecified" },
  { value: "A", text: "Generic (all operators)" },
  { value: "S", text: "SFR" },
  { value: "R", text: "RED" },
  { value: "V", text: "Virgin" },
  { value: "s", text: "SRR" },
  { value: "c", text: "Coriolis" },
  { value: "P", text: "Altice Portugal" },
  { value: "C", text: "Cable Vision" },
  { value: "p", text: "La Poste Mobile" },
  { value: "e", text: "EIT" },
  { value: "o", text: "OMT" }
];

const operatorTitles = {
  A: "Generic (all operators)",
  S: "SFR",
  R: "RED",
  V: "Virgin",
  s: "SRR",
  c: "Coriolis",
  P: "Altice Portugal",
  C: "Cable Vision",
  p: "La Poste Mobile",
  e: "EIT",
  o: "OMT"
};

const stbConfigUsageTypeList = ["Development", "Exploitation", "Certification", "Showroom", "VIP"];

const configPropertyTitles = {
  appli: "Main image / Application",
  ui: "User interface",
  bsl: "Recovery image / Bootstrap loader",
  data: "Data image",
};

const stbConfigProductVersionList = ["STB6", "STB7", "STB8"];

export function getConfigPropertyTitle(value) {
  return configPropertyTitles[value];
}

export function checkNested(obj, level, ...rest) {
  if (obj === undefined) return false;
  if (rest.length == 0 && obj.hasOwnProperty(level)) return true;
  return checkNested(obj[level], ...rest);
}

export function getOperatorList() {
  return operatorItemList;
}

export function getOperatorTitle(value) {
  return operatorTitles[value];
}

export function getStbConfigUsageTypeList() {
  return stbConfigUsageTypeList;
}

export function getStbConfigProductVersionList() {
  return stbConfigProductVersionList;
}

export function getStbConfigProtectedTagList() {
  return stbConfigProductVersionList.contact(stbConfigUsageTypeList);
}

export function getTextFromUserRecord(e) {
  return `${e.display_name || e.user_id.replace(/(\.prestataire)?@.*/, "")}`;
}

export function getTextFromRoleRecord(e) {
  return `${e.role_type ? `[${e.role_type}] ` : ""}${e.display_name ||
    e.role_id.replace(/(\.prestataire)?@.*/, "")}`;
}

export function vAutoCompDefData() {
  return {
    selected: null,
    loading: false,
    search: "",
    items: [],
  };
}

export function tryJSONParse(input, defaults) {
  try {
    return JSON.parse(input);
  } catch (err) {
    return defaults;
  }
}

export function getLocalParam(name, defaults) {
  try {
    const value = localStorage.getItem(name);
    if (!value) return defaults;
    return JSON.parse(value);
  } catch (err) {
    return defaults;
  }
}

export function setLocalParam(name, value) {
  localStorage.setItem(name, JSON.stringify(value));
}

export function autocompleteListUpdate(component, name, filter) {
  if (!component[name]) return;
  var list = component[name];
  if (list.loading) return;
  const path = list.rest.path(component);
  if (!path) {
    return;
  }
  var apiArgs = [];
  if (list.rest.args) {
    Object.keys(list.rest.args).forEach(k =>
      apiArgs.push(`${k}=${list.rest.args[k]}`)
    );
  }
  if (filter) {
    apiArgs.push(`filter=${encodeURIComponent(filter)}`);
  }
  list.loading = true;
  component.$axios
    .get(path + "?" + apiArgs.join("&"))
    .then(result => {
      list.items = (list.rest.filterCallback ? result.data.filter(list.rest.filterCallback) : result.data).map(list.rest.mapCallback);
      if (typeof list.selected === "object" && list.selected && !list.selected.text) {
        list.items.forEach(e => {
          if (e.value === list.selected.value) {
            list.selected.text = e.text;
          }
        });
      }
    })
    .catch(result => {
      component.processErrorResponse(result);
    })
    .finally(() => (list.loading = false));
}

export function makeMovableDialogs() { // make vuetify dialogs movable
  const d = {};
  document.addEventListener("mousedown", e => {
    const closestDialog = e.target.closest(".v-dialog.v-dialog--active");
    if (e.button === 0 && closestDialog != null && e.target.classList.contains("v-card__title")) { // element which can be used to move element
      d.el = closestDialog; // element which should be moved
      d.mouseStartX = e.clientX;
      d.mouseStartY = e.clientY;
      d.elStartX = d.el.getBoundingClientRect().left;
      d.elStartY = d.el.getBoundingClientRect().top;
      d.el.style.position = "fixed";
      d.el.style.margin = 0;
      d.oldTransition = d.el.style.transition;
      d.el.style.transition = "none"
    }
  });
  document.addEventListener("mousemove", e => {
    if (d.el === undefined) return;
    d.el.style.left = Math.min(
      Math.max(d.elStartX + e.clientX - d.mouseStartX, 0),
      window.innerWidth - d.el.getBoundingClientRect().width
    ) + "px";
    d.el.style.top = Math.min(
      Math.max(d.elStartY + e.clientY - d.mouseStartY, 0),
      window.innerHeight - d.el.getBoundingClientRect().height
    ) + "px";
  });
  document.addEventListener("mouseup", () => {
    if (d.el === undefined) return;
    d.el.style.transition = d.oldTransition;
    d.el = undefined
  });
  setInterval(() => { // prevent out of bounds
    const dialog = document.querySelector(".v-dialog.v-dialog--active");
    if (dialog === null) return;
    dialog.style.left = Math.min(parseInt(dialog.style.left), window.innerWidth - dialog.getBoundingClientRect().width) + "px";
    dialog.style.top = Math.min(parseInt(dialog.style.top), window.innerHeight - dialog.getBoundingClientRect().height) + "px";
  }, 100);
}
